import {
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  collection,
  query,
  where,
} from "firebase/firestore";

export async function fetchUserProfile({ db, user }) {
  return new Promise(async (resolve) => {
    try {
      const userRef = doc(db, "users", user);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        const userDate = userDoc.data();
        return resolve(userDate.profile);
      }
    } catch (error) {
      console.log(error);
      return resolve(error);
    }
  });
}

export async function updateUserProfileFields({ db, user, userProfilefields }) {
  return new Promise(async (resolve) => {
    try {
      const userRef = doc(db, "users", user);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        let updatedFields = {};

        userProfilefields.forEach((userProfileField) => {
          if (userProfileField.value.length) {
            updatedFields[userProfileField.name] = userProfileField.value;
          }
        });

        await updateDoc(userRef, {
          profile: updatedFields,
        });

        return resolve(updatedFields);
      }
    } catch (error) {
      console.log(error);
      return resolve(error);
    }
  });
}

export async function saveUserProfileStatus({ db, user, isProfileComplete }) {
  return new Promise(async (resolve) => {
    try {
      const userRef = doc(db, "users", user);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        await updateDoc(userRef, {
          isProfileComplete: isProfileComplete,
        });

        return resolve(true);
      }
    } catch (error) {
      console.log(error);
      return resolve(error);
    }
  });
}

export async function saveVideoProgress({
  db,
  user,
  video,
  learningPath,
  progress,
}) {
  return new Promise(async (resolve) => {
    try {
      const userRef = doc(db, "users", user);
      const progressRef = collection(userRef, "progress");

      const q = query(progressRef, where("type", "==", "video"));
      const progressSnapshot = await getDocs(q);

      /**
       * Check if progress collection exists for this user. If so, fall into
       * progress doc update logic. If collectio exists, run document checks
       * and add new / update existing docs as needed.
       */
      if (progressSnapshot.docs.length > 0) {
        /**
         * If progress type is videoProgress, check if there's an existing
         * document for this video. If there is, check if the new progress
         * is greater than the saved progress, if so, update the record. If
         * no record exists for this video, create one.
         */

        const docRef = doc(
          userRef,
          "progress",
          `video-${progress.learningPathId}-${progress.id}`
        );

        const docSnapshot = await getDoc(docRef);

        if (docSnapshot.exists()) {
          const docData = docSnapshot.data();
          
          if (progress.seconds > docData.seconds) {
            await updateDoc(docRef, {
              video: video.title,
              section: learningPath.title,
              ...progress,
              type: "video",
            });
            return resolve(true);
          } else {
            return resolve(true);
          }
        } else {
          await setDoc(docRef, {
            video: video.title,
            section: learningPath.title,
            ...progress,
            type: "video"
          });
          return resolve(true);
        }

        /**
         * If progress collection does not exist, create the new collection and
         * write the first progress document.
         */
      } else {
        const docRef = doc(
          userRef,
          "progress",
          `video-${progress.learningPathId}-${progress.id}`
        );
        await setDoc(docRef, {
          video: video.title,
          section: learningPath.title,
          ...progress,
          type: "video",
        });
        return resolve(true);
      }
    } catch (error) {
      console.log(error);
      return resolve(error);
    }
  });
}

export async function saveQuizProgress({ db, user, progress }) {
  return new Promise(async (resolve) => {
    try {
      const userRef = doc(db, "users", user);
      const progressRef = collection(userRef, "progress");

      const q = query(progressRef, where("type", "==", "quiz"));
      const progressSnapshot = await getDocs(q);

      /**
       * Check if progress collection exists for this user. If so, fall into
       * progress doc update logic. If collectio exists, run document checks
       * and add new / update existing docs as needed.
       */
      if (progressSnapshot.docs.length > 0) {
        /**
         * If progress type is videoProgress, check if there's an existing
         * document for this video. If there is, check if the new progress
         * is greater than the saved progress, if so, update the record. If
         * no record exists for this video, create one.
         */

        const docRef = doc(
          userRef,
          "progress",
          `quiz-${progress.learningPathId}-${progress.videoId}-${progress.questionIndex}`
        );

        const docSnapshot = await getDoc(docRef);
        
        if (docSnapshot.exists()) {
          await updateDoc(docRef, {
            ...progress,
            type: "quiz",
          });
          return resolve(true);
        
        } else {
          await setDoc(docRef, {
            ...progress,
            type: "quiz",
          });
          return resolve(true);
        }

        /**
         * If progress collection does not exist, create the new collection and
         * write the first progress document.
         */
      } else {
        const docRef = doc(
          userRef,
          "progress",
          `quiz-${progress.learningPathId}-${progress.videoId}-${progress.questionIndex}`
        );
        await setDoc(docRef, {
          ...progress,
          type: "quiz",
        });
        return resolve(true);
      }
    } catch (error) {
      console.log(error);
      return resolve(error);
    }
  });
}
